import React from 'react';
import { FileTextIcon, ArrowUpRightIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
const REPORTS = [{
  title: 'The State of Home Battery Storage, 2026',
  summary: 'A cross-manufacturer analysis of cycle life, real usable capacity and warranty terms across leading home battery systems.',
  tag: 'Energy'
}, {
  title: 'Household Water Filtration: Certified vs. Claimed',
  summary: 'We compared marketed contaminant-reduction claims against independent certification data across 14 systems.',
  tag: 'Water'
}, {
  title: 'Preparedness Spending & Real Resilience',
  summary: 'Where preparedness budgets deliver measurable resilience — and where they are wasted on redundant equipment.',
  tag: 'Preparedness'
}, {
  title: 'Smart Energy Monitors: Accuracy Under Load',
  summary: 'Benchmarking circuit-level energy monitors against a calibrated reference meter across varied household loads.',
  tag: 'Smart Home'
}];
export function Research() {
  return <>
      <PageHeader eyebrow="Research" title="Independent research that underpins our recommendations" intro="Deep, evidence-led analysis prepared under the Agreexa Trust Framework® — with sources and methodology disclosed." data-id="element-337" />

      <section className="max-w-editorial mx-auto px-6 pb-24" data-id="element-338">
        <div className="grid gap-px bg-stone-200 rounded-sm overflow-hidden border border-stone-200 sm:grid-cols-2" data-id="element-339">
          {REPORTS.map(r => <article key={r.title} className="group bg-white p-8 flex flex-col" data-id="element-340">
              <div className="flex items-center justify-between mb-5" data-id="element-341">
                <FileTextIcon className="h-6 w-6 text-trust-600" strokeWidth={1.5} data-id="element-342" />
                <span className="eyebrow text-stone-400" data-id="element-343">{r.tag}</span>
              </div>
              <h2 className="font-serif text-xl tracking-tightest text-ink leading-snug" style={{
            fontWeight: 600
          }} data-id="element-344">
                {r.title}
              </h2>
              <p className="mt-3 text-sm text-stone-600 leading-relaxed flex-1" data-id="element-345">
                {r.summary}
              </p>
              <span className="mt-6 inline-flex items-center gap-1 text-sm font-600 text-ink group-hover:text-trust-700 transition-colors" data-id="element-346">
                Read the report
                <ArrowUpRightIcon className="h-4 w-4" data-id="element-347" />
              </span>
            </article>)}
        </div>
      </section>
    </>;
}